type removeAdsPopupStorage = {
  serverSessionId: number;
  passedExercisesCounter: number;
  isPopupHidden: boolean;
};
export function useRemoveAdsPopup() {
  const storageKey = "removeAdsPopup";
  const hidePopup = () => {
    const popupData = window.sessionStorage.getItem(storageKey);
    if (!popupData) {
      return;
    }
    const parsedPopupData: removeAdsPopupStorage = JSON.parse(popupData);
    window.sessionStorage.setItem(
      storageKey,
      JSON.stringify({
        ...parsedPopupData,
        isPopupHidden: true,
      }),
    );
  };

  const incrementPassedExercisesCounter = (serverSessionId: number) => {
    const popupData = window.sessionStorage.getItem(storageKey);
    if (!popupData) {
      sessionStorage.setItem(
        storageKey,
        JSON.stringify({
          serverSessionId,
          passedExercisesCounter: 1,
          isPopupHidden: false,
        }),
      );
      return;
    }
    const parsedPopupData: removeAdsPopupStorage = JSON.parse(popupData);

    if (parsedPopupData.serverSessionId !== serverSessionId) {
      sessionStorage.setItem(
        storageKey,
        JSON.stringify({
          serverSessionId,
          passedExercisesCounter: 1,
          isPopupHidden: false,
        }),
      );
    } else {
      sessionStorage.setItem(
        storageKey,
        JSON.stringify({
          ...parsedPopupData,
          passedExercisesCounter: parsedPopupData.passedExercisesCounter + 1,
        }),
      );
    }
  };
  const checkPopup = (serverSessionId: number, showAnotherModal: boolean) => {
    const popupData = window.sessionStorage.getItem(storageKey);

    if (showAnotherModal) {
      return false;
    }
    if (!popupData) {
      return false;
    }
    const parsedPopupData: removeAdsPopupStorage = JSON.parse(popupData);
    if (parsedPopupData.serverSessionId !== serverSessionId) {
      return false;
    }
    return (
      parsedPopupData.passedExercisesCounter >= 3 &&
      !parsedPopupData.isPopupHidden
    );
  };
  return {
    hidePopup,
    checkPopup,
    incrementPassedExercisesCounter,
  };
}
